(function () {
  'use strict';

  const PLATE_COORDS = {
    'pulsera-pro':            { x1:333, y1:432, x2:685, y2:672 },
    'pulsera-fit':            { x1:322, y1:455, x2:702, y2:645 },
    'pulsera-extreme':        { x1:285, y1:437, x2:737, y2:673 },
    'pulsera-coach':          { x1:299, y1:442, x2:692, y2:684 },
    'pulsera-sports-id-lite': { x1:322, y1:475, x2:701, y2:644 },
    'pulsera-trail':          { x1:302, y1:398, x2:743, y2:684 },
    'sports-id-road':         { x1:190, y1:420, x2:840, y2:620 },
    'watch':                  { x1:350, y1:295, x2:625, y2:650 },
    'placa-lite':             { x1:151, y1:351, x2:874, y2:720 },
    'placa-extreme':          { x1:125, y1:280, x2:882, y2:732 },
    'default':                { x1:320, y1:432, x2:685, y2:672 },
  };

  // ── Utilidad: truncar texto sin loop infinito ────────────────────────────
  function truncateText(ctx, text, maxWidth) {
    if (ctx.measureText(text).width <= maxWidth) return text;
    let lo = 0, hi = text.length;
    while (lo < hi - 1) {
      const mid = Math.floor((lo + hi) / 2);
      if (ctx.measureText(text.slice(0, mid) + '...').width <= maxWidth) {
        lo = mid;
      } else {
        hi = mid;
      }
    }
    return text.slice(0, lo) + '...';
  }

  class EngravingPreview {
    constructor(root) {
      this.root = root;
      if (!this.root) return;

      this.mainImg   = this.root.querySelector('.sportsid-product__gallery-main-img');
      this.previewEl = this.root.querySelector('.sportsid-product__plate-preview');
      this.fields    = this.root.querySelectorAll('.sportsid-product__field');
      this.cartBtn   = this.root.querySelector('.sportsid-product__btn-cart');

      if (!this.previewEl || !this.mainImg) return;

      this._buildZoomOnly();
      this._bindFields();
      this._loadProductImage();
      this._updateCartState();
    }

    _buildZoomOnly() {
      this.previewEl.innerHTML = '';
      this.previewEl.style.cssText = 'margin:10px 0 6px;';

      this.callout = document.createElement('div');
      this.callout.style.cssText = [
        'display:flex;align-items:flex-start;gap:8px;',
        'background:#EAF3DE;border:1.5px solid #4EB848;',
        'border-radius:8px;padding:9px 12px;',
        'font-size:11px;color:#27500A;margin-bottom:8px;'
      ].join('');
      this.callout.innerHTML = [
        '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" style="flex-shrink:0;margin-top:1px;">',
        '<circle cx="7" cy="7" r="6" stroke="#4EB848" stroke-width="1.2"/>',
        '<path d="M7 4v3.5M7 9v.5" stroke="#4EB848" stroke-width="1.2" stroke-linecap="round"/>',
        '</svg>',
        '<span>Escribe tu nombre arriba y ver\u00e1s exactamente c\u00f3mo quedar\u00e1 grabado en la placa.</span>'
      ].join('');

      this.zoomWrap = document.createElement('div');
      this.zoomWrap.style.cssText = 'display:none;';

      const label = document.createElement('div');
      label.style.cssText = [
        'font-size:10px;font-weight:600;color:#555;',
        'text-transform:uppercase;letter-spacing:.05em;',
        'margin-bottom:5px;display:flex;align-items:center;gap:5px;'
      ].join('');
      label.innerHTML = '<span style="display:inline-block;width:8px;height:8px;border-radius:2px;background:#4EB848;"></span>As\u00ed quedar\u00e1 tu grabado';

      this.cvPlate = document.createElement('canvas');
      this.cvPlate.width  = 500;
      this.cvPlate.height = 140;
      this.cvPlate.style.cssText = [
        'width:100%;height:auto;display:block;',
        'border-radius:8px;border:0.5px solid rgba(0,0,0,.08);'
      ].join('');
      this.ctxPlate = this.cvPlate.getContext('2d');

      this.zoomWrap.append(label, this.cvPlate);
      this.previewEl.append(this.callout, this.zoomWrap);
    }

    _loadProductImage() {
      const cleanSrc = this.mainImg.src.replace(/\?.*$/, '').replace(/(_\d+x\d*|_large|_medium|_small)/, '');
      this.img = new Image();
      this.img.crossOrigin = 'anonymous';
      this.img.onload  = () => { this.imgLoaded = true; this._renderMainImg(); };
      this.img.onerror = () => { this.imgLoaded = false; };
      this.img.src = cleanSrc + '?width=1024';
    }

    _renderMainImg() {
      if (!this.imgLoaded) return;

      if (!this.cvMain) {
        const container = this.mainImg.parentElement;
        container.style.position = 'relative';
        this.cvMain = document.createElement('canvas');
        this.cvMain.style.cssText = [
          'position:absolute;top:0;left:0;',
          'width:100%;height:100%;',
          'pointer-events:none;border-radius:inherit;'
        ].join('');
        container.appendChild(this.cvMain);
      }

      this.cvMain.width  = this.mainImg.naturalWidth;
      this.cvMain.height = this.mainImg.naturalHeight;
      const ctx = this.cvMain.getContext('2d');
      ctx.clearRect(0, 0, this.cvMain.width, this.cvMain.height);

      const lines = this._getLines();
      if (lines.length === 0) return;

      const plate = this._getPlateCoords();
      const px = plate.x1;
      const py = plate.y1;
      const pw = plate.x2 - plate.x1;
      const ph = plate.y2 - plate.y1;

      // Tamaño de letra grande y legible
      const lineH    = Math.min(ph / 3.5, 30);
      const fontSize = Math.max(14, Math.min(lineH * 0.90, 24));
      const totalH   = lines.length * lineH;
      const startY   = py + (ph - totalH) / 2 + lineH / 2;

      ctx.save();
      ctx.font         = `700 ${fontSize}px 'Myriad Pro', monospace`;
      ctx.fillStyle    = 'rgba(30,30,30,0.82)';
      ctx.textAlign    = 'center';
      ctx.textBaseline = 'middle';
      lines.forEach((line, i) => {
        const txt = truncateText(ctx, line, pw * 0.84);
        ctx.fillText(txt, px + pw / 2, startY + i * lineH);
      });
      ctx.restore();

      // Contorno verde punteado
      ctx.save();
      ctx.strokeStyle = 'rgba(78,184,72,0.6)';
      ctx.lineWidth   = Math.max(1, this.cvMain.width / 500);
      ctx.setLineDash([5, 4]);
      ctx.strokeRect(px + 1, py + 1, pw - 2, ph - 2);
      ctx.restore();
    }

    _renderZoom() {
      const ctx = this.ctxPlate;
      const W   = this.cvPlate.width;
      const H   = this.cvPlate.height;
      ctx.clearRect(0, 0, W, H);

      const grad = ctx.createLinearGradient(0, 0, W, H);
      grad.addColorStop(0,   '#e8e8e8');
      grad.addColorStop(0.3, '#d8d8d8');
      grad.addColorStop(0.5, '#c8c8c8');
      grad.addColorStop(0.7, '#d2d2d2');
      grad.addColorStop(1,   '#e4e4e4');
      ctx.fillStyle = grad;
      ctx.fillRect(0, 0, W, H);

      ctx.save();
      ctx.globalAlpha = 0.04;
      for (let i = 0; i < H; i += 2) {
        ctx.fillStyle = i % 4 === 0 ? '#fff' : '#000';
        ctx.fillRect(0, i, W, 1);
      }
      ctx.restore();

      ctx.strokeStyle = '#bbb';
      ctx.lineWidth   = 1;
      ctx.strokeRect(1, 1, W - 2, H - 2);

      const lines = this._getLines();
      if (lines.length > 0) {
        const PAD    = 20;
        const lineH  = Math.min((H - PAD * 2) / 5, 22);
        const fontSize = Math.max(10, Math.min(lineH * 0.78, 16));
        const totalH = lines.length * lineH;
        const startY = H / 2 - totalH / 2 + lineH / 2;

        ctx.save();
        ctx.font         = `700 ${fontSize}px 'Myriad Pro', monospace`;
        ctx.textAlign    = 'center';
        ctx.textBaseline = 'middle';
        lines.forEach((line, i) => {
          const txt = truncateText(ctx, line, (W - PAD * 2) * 0.88);
          const y   = startY + i * lineH;
          ctx.fillStyle = 'rgba(255,255,255,0.45)';
          ctx.fillText(txt, W / 2 + 0.5, y + 0.5);
          ctx.fillStyle = 'rgba(25,25,25,0.78)';
          ctx.fillText(txt, W / 2, y);
        });
        ctx.restore();
      } else {
        ctx.font         = '13px sans-serif';
        ctx.fillStyle    = 'rgba(120,120,120,0.55)';
        ctx.textAlign    = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText('Tu texto aparecer\u00e1 aqu\u00ed', W / 2, H / 2);
      }
    }

    _toggleZoom() {
      const lines   = this._getLines();
      const hasText = lines.length > 0;
      this.zoomWrap.style.display = hasText ? 'block' : 'none';
      this.callout.style.display  = hasText ? 'none'  : 'flex';
    }

    _updateCartState() {
      if (!this.cartBtn) return;
      const f1      = this.root.querySelector('.sportsid-product__field');
      const hasName = f1 && f1.value.trim().length > 0;
      const priceEl = this.root.querySelector('[id^="cart-btn-price-"]');
      const price   = priceEl ? priceEl.textContent : '';
      if (hasName) {
        this.cartBtn.disabled      = false;
        this.cartBtn.style.opacity = '1';
        this.cartBtn.innerHTML     = `<span>Agregar al carrito${price ? ' \u2014 ' + price : ''}</span>`;
      } else {
        this.cartBtn.disabled      = true;
        this.cartBtn.style.opacity = '.5';
        this.cartBtn.innerHTML     = '<span>Escribe tu nombre para continuar</span>';
      }
    }

    _getLines() {
      return [...this.fields].map(f => f.value.trim()).filter(v => v.length > 0);
    }

    _getPlateCoords() {
      const d = this.previewEl.dataset;
      if (d.plateX1 && parseInt(d.plateX1) > 0)
        return { x1:+d.plateX1, y1:+d.plateY1, x2:+d.plateX2, y2:+d.plateY2 };
      const handle = window.location.pathname.split('/products/')[1]?.split('?')[0] || '';
      for (const [key, coords] of Object.entries(PLATE_COORDS))
        if (handle.includes(key)) return coords;
      return PLATE_COORDS.default;
    }

    _bindFields() {
      let debounceTimer;
      this.fields.forEach(field => {
        field.addEventListener('input', () => {
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(() => {
            this._renderMainImg();
            this._renderZoom();
            this._toggleZoom();
            this._updateCartState();
          }, 80);
        });
      });

      const thumbs = this.root.querySelectorAll('.sportsid-product__gallery-thumb');
      thumbs.forEach(thumb => {
        thumb.addEventListener('click', () => {
          setTimeout(() => {
            const newSrc = this.mainImg.src.replace(/\?.*$/, '') + '?width=1024';
            this.img.src = newSrc;
            this.img.onload = () => { this.imgLoaded = true; this._renderMainImg(); };
          }, 400);
        });
      });
    }
  }

  function init() {
    document.querySelectorAll('.sportsid-product').forEach(root => {
      new EngravingPreview(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', () => init());

})();